export default "__VITE_ASSET__Brm8qWIp__"